import { Icon } from '@chakra-ui/react';
import { GiConvergenceTarget } from 'react-icons/gi';

const SiteIcon = (props) => {
  return (
    <Icon as={GiConvergenceTarget} {...props} />
  );
}

export default SiteIcon;